// extracted by mini-css-extract-plugin
export default {"section__right":"Right_section__right__qSdMQ","section__right-container":"Right_section__right-container__v1ysq"};